/* POP US! — World-Class impact layer: sticky-header elevation + scroll reveal.
   Header elevation runs always; reveal is motion-only and gated by `.pu-js`
   (nothing is hidden unless JS confirms support). Includes a safety timeout. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sticky header elevation on scroll (independent of reduced-motion) */
  var header = document.querySelector('store-header.header');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          header.classList.toggle('pu-scrolled', window.scrollY > 12);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Scroll reveal (motion only) */
  if (reduce || !('IntersectionObserver' in window)) return;
  root.classList.add('pu-js');

  function setup() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
    // Skip the first section (hero) to avoid any above-the-fold flash.
    sections.slice(1).forEach(function (el) { el.classList.add('pu-reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pu-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.04 });

    document.querySelectorAll('.pu-reveal').forEach(function (el) { io.observe(el); });

    // Safety net: never leave content stuck hidden.
    setTimeout(function () {
      document.querySelectorAll('.pu-reveal:not(.pu-in)').forEach(function (el) {
        el.classList.add('pu-in');
      });
    }, 3500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();

/* ---- Collection: on-demand "Load more" (append products) ----
   Replaces the numbered prev/next pagination on collection pages. The initial page
   stays light (only the first page of products in the DOM); more load ONLY when the
   shopper clicks "Load more" — no auto/infinite scroll. Re-inits after facet/sort. */
(function () {
  function init() {
    var pagination = document.querySelector('.collection__pagination');
    var list = document.querySelector('product-list.product-list');
    if (!pagination || !list || pagination.dataset.puLoadmore) return;
    pagination.dataset.puLoadmore = '1';

    var nextLink = pagination.querySelector('a[rel="next"]');
    var nextUrl = nextLink ? nextLink.getAttribute('href') : null;

    pagination.style.display = 'none';

    var wrap = document.createElement('div');
    wrap.className = 'pu-loadmore';
    pagination.parentNode.insertBefore(wrap, pagination.nextSibling);
    if (!nextUrl) return; // single page — just hide the numbered nav

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--outline pu-loadmore__btn';
    btn.textContent = 'Load more';
    wrap.appendChild(btn);

    var loading = false;

    function load() {
      if (loading || !nextUrl) return;
      loading = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Loading…';
      fetch(nextUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = doc.querySelector('product-list.product-list');
        if (newList) {
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(newList.children).forEach(function (node) {
            frag.appendChild(document.importNode(node, true));
          });
          list.appendChild(frag);
        }
        var np = doc.querySelector('.collection__pagination a[rel="next"]');
        nextUrl = np ? np.getAttribute('href') : null;
        loading = false;
        btn.removeAttribute('aria-busy');
        if (nextUrl) { btn.textContent = 'Load more'; }
        else { wrap.innerHTML = '<p class="pu-loadmore__end">You’ve reached the end</p>'; }
      }).catch(function () {
        loading = false; btn.removeAttribute('aria-busy'); btn.textContent = 'Load more';
      });
    }

    btn.addEventListener('click', load);
  }

  function boot() {
    init();
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var pag = document.querySelector('.collection__pagination');
        if (pag && !pag.dataset.puLoadmore) init();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
